import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';

export default function GetProductDetail(productLandingUrl) {
  const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const product = account.accountProducts.find(product => productLandingUrl.includes(product.productLandingUrl));
  return product;
}
